import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  TextField
} from '@mui/material';
import { Warning, Delete } from '@mui/icons-material';

const ConfirmDeleteDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  course,
  loading = false
}) => {
  const [confirmText, setConfirmText] = useState('');

  const handleClose = () => {
    setConfirmText('');
    onClose();
  };

  const handleConfirm = () => {
    if (confirmText === 'ELIMINAR') {
      onConfirm(course.id);
      setConfirmText('');
    }
  };

  const isConfirmValid = confirmText === 'ELIMINAR';

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ 
        backgroundColor: '#fff3cd', 
        color: '#856404',
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}>
        <Warning sx={{ color: '#f57c00' }} />
        Confirmar Eliminación de Curso
      </DialogTitle>
      
      <DialogContent sx={{ pt: 3 }}>
        {course && (
          <>
            <Box sx={{ 
              border: '1px solid #e0e0e0', 
              borderRadius: 2, 
              p: 2, 
              mb: 3,
              backgroundColor: '#f9f9f9'
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                {course.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Creado: {new Date(course.createdAt).toLocaleDateString()} | 
                Estudiantes inscritos: {course.enrolledCount || 0}
              </Typography>
            </Box>
            
            <Alert severity="warning" sx={{ mb: 2 }}>
              Esta acción no se puede deshacer. El curso y todo su contenido se eliminarán permanentemente.
            </Alert>
            
            <Typography variant="body1" sx={{ mb: 2 }}>
              Para confirmar la eliminación, escribe <strong>ELIMINAR</strong> en el campo de abajo:
            </Typography>
            
            <TextField
              fullWidth
              placeholder="Escribe ELIMINAR para confirmar"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
              error={confirmText !== '' && !isConfirmValid}
              helperText={confirmText !== '' && !isConfirmValid ? 'Debe escribir exactamente "ELIMINAR"' : ''}
              autoComplete="off"
              sx={{ mb: 2 }}
            />
          </>
        )}
      </DialogContent>
      
      <DialogActions sx={{ p: 3, gap: 2 }}>
        <Button 
          onClick={handleClose} 
          variant="outlined"
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={!isConfirmValid || loading}
          startIcon={loading ? null : <Delete />}
        >
          {loading ? 'Eliminando...' : 'Eliminar Curso'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog; 